import { forwardRef, ReactElement } from "react";
import { TransitionProps } from "notistack";
import { Slide } from "@mui/material";

export const CustomTransition = forwardRef<
  HTMLElement,
  TransitionProps & { children: ReactElement }
>(function CustomTransition(props, ref) {
  const { children, onEnter, onExited, ...other } = props;

  // Use direction "up" on enter or entered, "left" on exit or exited
  const direction = props.in ? "up" : "right";

  return (
    <Slide
      {...other}
      direction={direction}
      ref={ref}
      onEnter={onEnter}
      onExited={onExited}
    >
      {children}
    </Slide>
  );
});
